import { Expression } from '../Expression.js';
export class ContextExpression extends Expression {
    evaluate(visitor) {
        if (this.accept(visitor)) {
            visitor.addEvaluatedContext(this);
        }
    }
}
//# sourceMappingURL=ContextExpression.js.map